
<script>

export default {
  name: "create-flix-playlist-modal",
  methods:{
    showCreatePlaylistModal(){
      $("#flixPlaylistModal").modal("show")
    }
  }
}
</script>

<style scoped>
</style>